import { Link } from "react-router-dom";

// Header lockup (mark + FSRS wordmark) as a real route link to "/".
// Children stay the existing Logo markup so surrounding motto/tagline
// styling is unchanged. The focus ring lives on .fsrs-home-logo-link.
export default function HomeLogoLink({
    children,
    className = "",
    testId = "header-home-logo-link",
}) {
    return (
        <Link
            to="/"
            aria-label="FSRS home"
            data-testid={testId}
            className={`fsrs-home-logo-link inline-flex cursor-pointer items-center ${className}`.trim()}
        >
            {children}
        </Link>
    );
}
